import { Main } from '~/models/main';
import type { ServicesGroup } from '~/models/services-group';

export const mainService = {
	fetch: async (): Promise<Main.Model | null> => {
		const params = {
			fields: [
				'*',
				'imageLeft.*',
				'imageRight.*',
				'servicesLink.url',
				'servicesGroup.services_group_id.*',
			],
		};

		try {
			const response = await $fetch<
				Omit<Main.Model, 'servicesGroup'> & {
					servicesGroup: { services_group_id: ServicesGroup.Model }[];
				}
			>(Main.api, {
				method: 'POST',
				body: { params },
			});

			/** Resolve services group */
			const servicesGroup = response.servicesGroup.reduce((acc, { services_group_id }) => {
				acc.push(services_group_id);
				return acc;
			}, [] as ServicesGroup.Model[]);

			return { ...response, servicesGroup };
		} catch (error) {
			console.error('Failed to fetch Main:', error);

			return null;
		}
	},
};
